<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onDismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">
            {{ titleText | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <p>
            {{ bodyText | translate }}
        </p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">{{ "cancel" | translate }}</button>
        <button type="button" class="btn btn-success" (click)="onConfirm()">{{ "add" | translate }}</button>
    </div>
</div>
